import { Box, Fade, Typography, Button, Snackbar, Alert } from "@mui/material";
import { Loading } from "../../common/components";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  finalizarEquipo,
  getEquipoById,
  updateEquipo,
} from "../../helpers/equipos";
import { InfoGeneral } from "../components/DetallesEquipo/InfoGeneral";
import { getAcolitosActivos } from "../../helpers/acolitos";
import { Integrantes } from "../components/DetallesEquipo/Integrantes";
import { CustomModal } from "../../common/components/CustomModal";
import {
  Delete,
  Save,
  SentimentVeryDissatisfied,
  ThumbUpAlt,
} from "@mui/icons-material";

export const DetallesEquipo = () => {
  //Nommbre de la página
  document.title = "Detalles del equipo";

  //Obtener el id del equipo
  const { id: idEquipo } = useParams();

  //Obtener el equipo
  const [equipo, setEquipo] = useState({});
  const [loading, setLoading] = useState(true);
  const [acolitos, setAcolitos] = useState([]);
  const [textLoading, setTextLoading] = useState(
    "Obteniendo información del equipo"
  );
  const [showAlert, setShowAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState("Error al guardar los cambios");
  const [showModal, setShowModal] = useState(false);
  const [showCambiosGuardados, setShowCambiosGuardados] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [alertDelete, setAlertDelete] = useState(false);

  const getData = async () => {
    const e = await getEquipoById(idEquipo);
    setEquipo(e);
    const ac = await getAcolitosActivos();
    setTextLoading("Obteniendo información de los acólitos");
    setAcolitos(ac["data"]);
    setLoading(false);
  };

  const validarCampos = () => {
    if (equipo.nombre === "" || equipo.nombre === undefined) {
      setErrorAlert("Error: el nombre del equipo no puede estar vacío.");
      return false;
    }
    if (equipo.id_capitan === null || equipo.id_capitan === undefined) {
      setErrorAlert("Error: debe seleccionar un capitán para el equipo.");
      return false;
    }
    //Recorrer cada acólito y verificar que el id no sea null
    let error = false;
    equipo.acolitos.forEach((a) => {
      if (a.id === null || a.id === undefined) {
        setErrorAlert("Error: No puede dejar campos en blanco.");
        error = true;
      }
    });
    if (error) return false;
    //Verificar que el array de acolitos sea mayor a 0
    if (equipo.acolitos.length === 0) {
      setErrorAlert("Error: debe agregar al menos un acólito al equipo.");
      return false;
    }
    return true;
  };
  const guardarCambios = async () => {
    setGuardando(true);
    let error = true;
    if (validarCampos()) {
      //Guardar los cambios
      const resp = await updateEquipo(equipo);
      if (resp.status === 200) {
        setShowCambiosGuardados(true);
        error = false;
      } else {
        error = true;
      }
    }
    setGuardando(false);
    setShowModal(false);
    if (error) {
      setShowAlert(true);
    }
  };

  const finEquipo = async () => {
    setGuardando(true);
    //Finalizar el equipo
    const resp = await finalizarEquipo(equipo);
    if (resp.status === 200) {
      setShowCambiosGuardados(true);
    } else {
      console.log("Error al finalizar equipo");
      setShowAlert(true);
    }
    setGuardando(false);
    setAlertDelete(false);
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <Loading texto={textLoading} />;
  }

  if (equipo.message) {
    return (
      <div>
        <Fade in={true} timeout={1000}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "60vh",
            }}
          >
            <SentimentVeryDissatisfied
              style={{ fontSize: 100, marginBottom: 30 }}
              color="secondary"
            />
            <Typography
              id="transition-modal-title"
              variant="h4"
              color="secondary"
              fontWeight={500}
            >
              NO SE ENCONTRÓ ESE EQUIPO
            </Typography>
          </Box>
        </Fade>
      </div>
    );
  }

  return (
    <>
      <InfoGeneral equipo={equipo} setEquipo={setEquipo} acolitos={acolitos} />
      <Integrantes equipo={equipo} setEquipo={setEquipo} acolitos={acolitos} />
      {/* Alerta de error */}
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert
          onClose={() => setShowAlert(false)}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {errorAlert}
        </Alert>
      </Snackbar>
      {/* Modal para confirmar que deseamos guardar los cambios */}
      {
        <CustomModal
          open={showModal}
          funBtn1={guardarCambios}
          funBtn2={() => setShowModal(false)}
          btnDisabled={guardando}
        />
      }
      {/* Modal para confirmar que se guardaron los cambios */}
      <CustomModal
        open={showCambiosGuardados}
        title="Cambios guardados"
        text="Los cambios se guardaron correctamente."
        txtBtn1="Aceptar"
        funBtn1={() => (window.location.href = "/equipos")}
        // iconBtn1={<ThumbUpAlt />}
        segundoBtn={false}
      />
      {/* Modal para confirmar la finalización del equipo */}
      <CustomModal
        open={alertDelete}
        title="¿Está seguro que desea finalizar el equipo?"
        text=" Esta acción no se puede deshacer."
        txtBtn1="Sí"
        txtBtn2="No"
        funBtn1={() => finEquipo()}
        iconBtn1={<ThumbUpAlt />}
        segundoBtn={true}
        funBtn2={() => setAlertDelete(false)}
        btnDisabled={guardando}
      />
      <div style={{ position: "fixed", bottom: 20, right: 20 }}>
        <Button
          startIcon={<Delete style={{ fontSize: 20 }} />}
          sx={{
            borderRadius: 2,
            boxShadow: 8,
            transition: "transform 0.3s",
            bgcolor: "error.main",
            "&:hover": {
              transform: "scale(1.1)",
            },
            fontSize: 15,
            fontWeight: 900,
            padding: "10px 20px",
            marginRight: 5,
            color: "white",
          }}
          onClick={() => setAlertDelete(true)}
        >
          Finalizar equipo
        </Button>
        <Button
          startIcon={<Save style={{ fontSize: 20 }} />}
          sx={{
            borderRadius: 2,
            boxShadow: 8,
            transition: "transform 0.3s",
            bgcolor: "white",
            "&:hover": {
              transform: "scale(1.1)",
            },
            fontSize: 20,
            fontWeight: 900,
            padding: "10px 20px",
          }}
          onClick={() => setShowModal(true)}
        >
          Guardar
        </Button>
      </div>
    </>
  );
};
